import { TextTestID } from "@/constants/TestID";
import { FAIconName, Icon, Text } from "@/ui/core";
import { HStack } from "@/ui/layout";
import { ColorToken } from "@/ui/theme/tokens";
import { getTimeRange } from "@/utils/date.util";
import { joinTestIDs } from "@/utils/string.util";

interface EventTimeDisplayProps extends ViewWithTestID {
  endDate: string;
  isRecurring?: boolean;
  startDate: string;
}

const EventCardTimeDisplay = ({
  endDate,
  isRecurring,
  startDate,
  testID,
}: EventTimeDisplayProps) => {
  return (
    <HStack alignItems="center" gap={6}>
      {isRecurring && (
        <Icon
          color={ColorToken.NeutralSecondary}
          name={FAIconName.Refresh}
          size="sm"
          testID={joinTestIDs(testID, "frequency")}
        />
      )}
      <Text
        color={ColorToken.NeutralSecondary}
        testID={joinTestIDs(testID, TextTestID.Time)}
        variant="caption"
      >
        {getTimeRange({ endDate, startDate })}
      </Text>
    </HStack>
  );
};

export default EventCardTimeDisplay;
